module.exports = __webpack_public_path__ + "static/media/fail.d541ad8a.png";